import { PkSpinner } from '@uefadigital/panenka-react';
import { memo, useMemo } from 'react';

import Draw from '@apps/draw/Draw';
import { DrawOptionsProvider, DrawProvider } from '@apps/draw/store';
import type { DrawOptions } from '@apps/draw/store/types';
import { useDrawCentreOptions } from '@apps/draw-centre/store';

const DrawPots = () => {
  const { options } = useDrawCentreOptions();
  const drawOptions = useMemo<DrawOptions>(
    () => ({
      ...options,
      isPotsTab: true,
    }),
    [options],
  );
  return (
    <DrawOptionsProvider options={drawOptions}>
      <DrawProvider>
        <Draw
          placeholder={
            <div>
              <PkSpinner />
            </div>
          }
        />
      </DrawProvider>
    </DrawOptionsProvider>
  );
};

export default memo(DrawPots);
